import React from 'react';
import classNames from 'classnames';

import Text from '../../common/Text';
import Row from '../../common/Row';
import Locale from '../../Translate/Locale';
import ArrowDownLightIcon from '../../../icons/arrow-down-light.svg';
import ArrowUpLightIcon from '../../../icons/arrow-up-light.svg';

import styles from './FilterSelectButton.scss';

type FilterSelectButtonProps = {
  children: string;
  label?: string;
  ariaLabel?: string;
  isActive: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
};

function FilterSelectButton(props: FilterSelectButtonProps) {
  const { children, label, ariaLabel, isActive, onClick, disabled } = props;

  return (
    <button
      className={classNames(styles.header, { active: isActive })}
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
    >
      <Row spacing={8}>
        <Text>
          <Locale>{children}</Locale>
        </Text>
        {label && (
          <div className={classNames(styles.label, { active: isActive })}>
            <Locale>{label}</Locale>
          </div>
        )}
        {isActive ? <ArrowUpLightIcon className={styles.iconUp} /> : <ArrowDownLightIcon className={styles.iconDown} />}
      </Row>
    </button>
  );
}

export default React.memo(FilterSelectButton);
